import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './FormItem.scss';

export default function FormItem({ children, className }) {
	return (
		<div className={classnames('ss-form-item', className)}>{children}</div>
	);
}

FormItem.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
};
